import ProductSlider from '@/organisms/ProductSlider'

import { OtherProductsProps } from '../../ts'
import TransHeading from './includes/TransHeading'

function OtherProducts({ creator, products }: OtherProductsProps) {
  const { nickname, slug } = creator

  if (!products || products.length <= 0) return null

  return (
    <>
      <div className="box">
        <div className="pt-6 mt-8 border-t-2 xl:mt-16 xl:pt-16 border-violet-5">
          <h2 className="mb-6 text-xl font-medium break-words md:text-2xl">
            <TransHeading nickname={nickname} slug={slug} />
          </h2>
        </div>
      </div>
      <ProductSlider asFeatured products={products} />
    </>
  )
}

export default OtherProducts
